var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 90 90",
    style: {
      enableBackground: "new 0 0 90 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#53ADF8;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45,5C22.9,5,5,20.7,5,40.1c0,11.1,5.7,21,14.6,27.6l-3.4,13.5c-0.3,1.2,0.1,2.5,1,3.3 c0.6,0.5,1.3,0.8,2.1,0.8c0.4,0,0.9-0.1,1.3-0.3l17.1-8.6c2.4,0.3,4.9,0.5,7.3,0.5c22.1,0,40-15.7,40-35.1 C85,20.7,67.1,5,45,5z M45,70.8c-2.3,0-4.6-0.2-6.9-0.6c-0.6-0.1-1.2,0-1.8,0.3l-12.6,6.3l2.3-9.3c0.2-0.8,0-1.7-0.5-2.4 C17.2,58.7,11,49.8,11,40.1C11,24,26.2,11,45,11s34,13,34,29.1S63.8,70.8,45,70.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 30,
    cy: 40.1,
    r: 4.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 45,
    cy: 40.1,
    r: 4.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 60,
    cy: 40.1,
    r: 4.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessages);
export default __webpack_public_path__ + "static/media/Messages.51ca4d2559476271838b9c6606e15b8c.svg";
export { ForwardRef as ReactComponent };